import validator from 'validator';

const createRule = function (constraints) {
  return function validate (value) {
    let errors = [];

    constraints.forEach((constraint) => {

      if (typeof constraint[0] === 'string') {
        if (!validator.isEmail(value)) {
          errors.push(constraint[1]);
        }
      } else if (typeof constraint[0] === 'function') {
        if (!constraint[0](value)) {
          errors.push(constraint[1]);
        }
      }

    });

    return errors;
  };
};

export default createRule;


// WEBPACK FOOTER //
// ./client/helpers/createRule.js